import React, { useState } from "react";
import mul_cities from "../constants/mul_cities";
import Axios from "axios";

const AddMulJudge = () => {
  const [competitions, setCompetitions] = useState([]);
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [judgeObj, setJudgeObj] = useState({
    name: "",
    email: "",
    competition: [],
    phone: "",
  });

  const getCompetitions = (cityName) => {
    Axios.get(
      `https://ashish.moodi.org/multicity/get_mul_compi?city=${cityName}`
    )
      .then((res) => setCompetitions(res.data))
      .catch((err) => console.error(err));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitDisabled(true);
    Axios.post(
      "https://ashish.moodi.org/multicity/add_mul_judge",
      {
        competition: judgeObj.competition,
        name: judgeObj.name,
        phone: judgeObj.phone,
        email: judgeObj.email,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        if (res.data.status === "done") {
          window.alert("Judge Added Successfully!");
          setSubmitDisabled(false);
          window.location.reload();
        }
      })
      .catch((err) => console.error(err));
  };

  const onCityChange = (e) => {
    getCompetitions(e.target.value);
  };

  const onChange = (e) => {
    setJudgeObj({ ...judgeObj, [e.target.name]: e.target.value });
  };

  const onCompiChange = (e) => {
    var options = e.target.options;
    var value = [];
    for (var i = 0, l = options.length; i < l; i++) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    judgeObj.competition = value;
  };

  return (
    <div className="container-fluid">
      <h2>Add Judge</h2>
      <form onSubmit={handleSubmit}>
        <div class="mb-3">
          <label for="exampleInputEmail1" class="form-label">
            Name
          </label>
          <input
            type="text"
            class="form-control"
            id="exampleInputEmail1"
            required
            name="name"
            onChange={onChange}
          />
        </div>
        <div class="mb-3">
          <label for="exampleInputEmail1" class="form-label">
            Phone
          </label>
          <input
            type="tel"
            class="form-control"
            id="exampleInputEmail1"
            required
            name="phone"
            onChange={onChange}
          />
        </div>
        <div class="mb-3">
          <label for="exampleInputEmail1" class="form-label">
            Email address
          </label>
          <input
            type="email"
            class="form-control"
            id="exampleInputEmail1"
            aria-describedby="emailHelp"
            required
            name="email"
            onChange={onChange}
          />
        </div>
        <div class="mb-3">
          <label for="exampleInputPassword1" class="form-label">
            City
          </label>
          <select
            class="form-select"
            aria-label="Default select example"
            onChange={onCityChange}
            required
          >
            <option value="">Select City</option>
            {mul_cities.map((city) => {
              return <option value={city.cityName}>{city.cityName}</option>;
            })}
          </select>
        </div>
        <div class="mb-3">
          <label for="exampleInputPassword1" class="form-label">
            Competition (Select all that apply by holding CMD(on mac) or CTRL(on
            windows))
          </label>
          <select
            class="form-select"
            aria-label="Default select example"
            required
            onChange={onCompiChange}
            name="competition"
            multiple
          >
            {competitions.map((competition) => {
              return (
                <option value={competition.mcId}>{competition.mcName}</option>
              );
            })}
          </select>
        </div>
        {submitDisabled ? (
          <button
            className="btn btn-primary w-100 mt-3"
            type="submit"
            disabled={submitDisabled}
          >
            <span
              className="spinner-border spinner-border-sm"
              aria-hidden="true"
            ></span>
            <span role="status">Submitting...</span>
          </button>
        ) : (
          <input
            type="submit"
            value="Submit"
            className="btn btn-primary w-100 mt-3"
          />
        )}
      </form>
    </div>
  );
};

export default AddMulJudge;
